import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Camera, ArrowRight, Loader2, Upload } from "lucide-react";
import { useApi, useFetch, errMsg } from "../lib/api";
import { CameraCapture } from "./CameraCapture";
import { sendDoc, QUEUED_MSG } from "../lib/offline";

export const PhotoGapCard = () => {
  const { data } = useFetch("/kyc/photo-gaps");
  if (!data?.missing) return null;
  return (
    <Link to="/workers?nophoto=1" data-testid="photo-gap-alert" className="c-surface c-rise mb-6 flex items-center justify-between gap-3 p-4 !border-sky-500/30 hover:!border-sky-500/60">
      <span className="text-sm text-sky-300"><Camera size={15} className="inline mr-2" /><span data-testid="photo-gap-count">{data.missing}</span> active worker(s) have no passport photo</span>
      <span className="text-xs text-sky-400 flex items-center gap-1">Add photos<ArrowRight size={12} /></span>
    </Link>);
};

export const PhotoUploadButton = ({ w, onDone }) => {
  const api = useApi();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [cam, setCam] = useState(false);
  const pick = async (file) => {
    if (!file) return;
    if (!/^image\/(jpe?g|png)$/.test(file.type)) return toast.error("Choose a JPG or PNG photo");
    if (file.size > 10 * 1024 * 1024) return toast.error("The photo must be 10 MB or smaller");
    setBusy(true);
    try {
      if ((await sendDoc(api, w, "PHOTO", file, "Passport photo")) === "queued") toast.message(QUEUED_MSG);
      else { toast.success(`Photo added for ${w.worker_full_name}`); onDone(); }
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <span className="inline-flex items-center gap-1">
      <button onClick={() => setCam(true)} disabled={busy} title="Take photo with camera" className="inline-flex items-center gap-1 rounded-md border border-sky-500/30 px-2 py-1 text-[11px] text-sky-300 hover:bg-sky-500/10 disabled:opacity-50" data-testid={`photo-camera-btn-${w.id}`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Camera size={12} />}Camera</button>
      <button onClick={() => ref.current?.click()} disabled={busy} title="Upload passport photo" className="inline-flex items-center gap-1 rounded-md border border-sky-500/30 px-2 py-1 text-[11px] text-sky-300 hover:bg-sky-500/10 disabled:opacity-50" data-testid={`photo-upload-btn-${w.id}`}>
        <Upload size={12} />Upload</button>
      <input ref={ref} type="file" hidden accept=".jpg,.jpeg,.png" onChange={(e) => { pick(e.target.files[0]); e.target.value = ""; }} data-testid={`photo-upload-input-${w.id}`} />
      {cam && <CameraCapture onPhoto={pick} onClose={() => setCam(false)} />}
    </span>);
};
